<script setup lang="ts">
  import { type AIChatSessionMessage } from '@/types/generated'
  import { AIChatSessionMessageRoleEnum } from '@/types/generated'
  import AiChatAssistantMessageRenderer from './AiChatAssistantMessageRenderer.vue'
  import AiChatUserMessageRenderer from './AiChatUserMessageRenderer.vue'
  import AiChatSystemMessageRenderer from './AiChatSystemMessageRenderer.vue'
  import { inject } from 'vue'

  defineProps<{
    message: AIChatSessionMessage
  }>()

  const handleDocumentClick = inject('handleDocumentClick') as (document: any) => Promise<void>
</script>

<template>
  <AiChatSystemMessageRenderer
    v-if="message.role === AIChatSessionMessageRoleEnum.SYSTEM"
    :message="message"
  />
  <AiChatAssistantMessageRenderer
    v-if="message.role === AIChatSessionMessageRoleEnum.ASSISTANT"
    :message="message"
    @document-click="handleDocumentClick"
  />
  <AiChatUserMessageRenderer
    v-else-if="message.role === AIChatSessionMessageRoleEnum.USER"
    :message="message"
  />
</template>
